import type { FaireProductEntity } from "../../entity_types/product";

export const p_ckdfxv5ne2: FaireProductEntity = {
  token: "p_ckdfxv5ne2",
  type: "product",
  name: "10\" x 8\" x 6\" Shipping Boxes - Bundle of 25",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/465d29e248963a7e0d653bccd114d566fd89337b2a2e2b6eaadd3ff4358cf979.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e58b4d921eb7c2b906b1076eab06bfb51e6e930436b550a265de5fbb056dbcc2.jpeg",
    "https://cdn.faire.com/fastly/5f297e665e8353e107280bb1f1ab0c88e2a33c0fbe05c836777b492bffd044a5.jpeg",
    "https://cdn.faire.com/fastly/589ba67d9f5dda10d5b11b21444bd570200a358ebe32bcc3db20fd9e977b85e6.jpeg"
  ],
  priceDollars: 15,
  description: "Versatile 10\" x 8\" x 6\" corrugated shipping boxes for small to medium merchandise. The size fits a wide range of retail and online orders without needing an oversized carton.\n\n- Size: 10\" W x 8\" D x 6\" H\n- Material: corrugated\n- Ships and stores flat; assemble and seal when needed\n- Quantity: 25 boxes per bundle\n\nGood for packing customer orders, store transfers and stockroom storage.",
  tags: [],
  msrpDollars: 22.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:06.343Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
